import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';
// Fake data for social proof
const RECENT_PURCHASES = [{
  name: 'María G.',
  location: 'Ciudad de México',
  time: 'hace 2 minutos'
}, {
  name: 'Ana P.',
  location: 'Bogotá',
  time: 'hace 5 minutos'
}, {
  name: 'Sofía L.',
  location: 'Madrid',
  time: 'hace 12 minutos'
}, {
  name: 'Valentina R.',
  location: 'Buenos Aires',
  time: 'hace 8 minutos'
}, {
  name: 'Camila M.',
  location: 'Santiago',
  time: 'hace 15 minutos'
}];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    // Initial delay before first notification
    const initialTimer = setTimeout(() => {
      if (!isDismissed) setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed) return;
    let interval: NodeJS.Timeout;
    if (isVisible) {
      // Hide after 6 seconds
      interval = setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    } else {
      // Show next notification after random delay (10-20s)
      const randomDelay = Math.floor(Math.random() * 10000) + 10000;
      interval = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % RECENT_PURCHASES.length);
        setIsVisible(true);
      }, randomDelay);
    }
    return () => clearTimeout(interval);
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  const purchase = RECENT_PURCHASES[currentIndex];
  return <AnimatePresence data-id="element-229">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] md:w-auto" data-id="element-230">
          <div className="bg-white rounded-xl shadow-2xl shadow-[#14B8A6]/20 border border-[#5EEAD4]/30 p-3 flex items-center gap-4 relative overflow-hidden" data-id="element-231">
            {/* Close button */}
            <button onClick={() => setIsDismissed(true)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600 p-1" data-id="element-232">
              <X size={14} data-id="element-233" />
            </button>

            {/* Product Image */}
            <div className="relative flex-shrink-0 w-16 h-20 bg-[#F0FDFA] rounded-lg overflow-hidden border border-[#5EEAD4]/20" data-id="element-234">
              <img src="https://cdn.magicpatterns.com/uploads/hZhPEEpQETkzDV2iTWL4vN/d135fca7-e6f3-4c98-aa3d-923f61a52d3b.jpg" alt="Guía Anti-Hinchazón" className="w-full h-full object-cover" data-id="element-235" />
            </div>

            {/* Content */}
            <div className="flex-1 pr-4" data-id="element-236">
              <div className="flex items-center gap-1 mb-1" data-id="element-237">
                <p className="font-bold text-[#4A3B32] text-sm" data-id="element-238">
                  {purchase.name}
                </p>
                <span className="text-xs text-gray-400" data-id="element-239">•</span>
                <p className="text-xs text-gray-500" data-id="element-240">{purchase.location}</p>
              </div>

              <p className="text-xs text-[#5D5D5D] leading-tight mb-1" data-id="element-241">
                Compró <span className="font-medium" data-id="element-242">Guía Anti-Hinchazón</span>
              </p>

              <div className="flex items-center justify-between mt-1" data-id="element-243">
                <p className="text-xs font-bold text-[#14B8A6]" data-id="element-244">$9.97</p>
                <div className="flex items-center text-[10px] text-gray-400" data-id="element-245">
                  <CheckCircle size={10} className="text-green-500 mr-1" data-id="element-246" />
                  {purchase.time}
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}